<template>
  <div class="nav">
    <!-- 上半部分 -->
    <div class="nav_header">
      <!-- APP信息 -->
      <div class="logo">
        <img src="../assets/logo.webp" alt="logo" />
        <p>openice</p>
        <p>V1.0.0</p>
      </div>

      <!-- 协议 -->
      <div class="nav_protocol">
        <router-link to="/provacy">
          <div>
            <span>{{ $t("language.policy") }}</span>
          </div>
        </router-link>
      </div>
      <div class="nav_protocol">
        <router-link to="/agree">
          <div>
            <span>{{ $t("language.user") }}</span>
          </div>
        </router-link>
      </div>
      <div class="nav_protocol">
        <router-link to="/sdk">
          <div>
            <span>{{ $t("sdk.Index_title") }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="nav_kong"></div>
    <!-- 下半部分 -->
    <div class="nav_footer">
      <div class="nav_withdraw">
        <a href="#">{{ $t("language.withdrawal") }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: localStorage.getItem("lang") || "zh_CN",
    };
  },
  mounted() {
    let display = this.$route.query.display;
    if (display == "light") {
      document.querySelector("html").className = "";
    } else if (display == "dark") {
      document.querySelector("html").className = "dark";
    }
    let lang = this.$route.query.lang;
    this.$i18n.locale = lang || "zh_CN";
  },
};
</script>

<style>
a {
  text-decoration: none;
}

body {
  min-width: 320px;
  max-width: 750px;
  margin: 0 auto;
  font-family: "PingFang SC-Regular";
  background-color: var(--body_bg);
  font-size: 16px;
}

.nav {
  position: relative;
  margin: 0 auto;
}

.setIcon {
  position: absolute;
  right: 15px;
  top: 15px;
}

.nav_icon_color {
  color: var(--nav_icon_color);
}

/* nav上半部分 */
.nav_header {
  width: 100%;
  background-color: var(--body_bg);
  padding-top: 30px;
}

.nav_header .logo {
  width: 100%;
  height: 186px;
  text-align: center;
  font-size: 15px;
  color: var(--nav_header_text_color);
}

.nav_header .logo p {
  font-size: 16px;
}

.nav_header .logo p:last-child {
  font-size: 14px;
  color: #96989a;
}

.nav_header .logo img {
  width: 50px;
  height: 50px;
  padding-top: 42px;
}

.nav_protocol {
  width: 100%;
  height: 42px;
  background-color: var(--body_bg);
}

.nav_protocol a {
  display: block;
  width: 100%;
  height: 100%;
  color: var(--nav_header_text_color);
  line-height: 33px;
}

.nav_protocol a div {
  position: relative;
  margin: 0 15px;
  padding-bottom: 6px;
  border-bottom: 1px solid #ccc;
}

.nav_protocol:last-child a div {
  border: 0;
  padding-bottom: 0;
  margin-top: 8px;
}

.nav_protocol a div span::before {
  content: "";
  position: absolute;
  top: 12px;
  right: 2px;
  width: 8px;
  height: 8px;
  border-right: 1px solid #929292;
  border-bottom: 1px solid #929292;
  transform: rotate(-45deg);
}

.nav_kong {
  width: 100%;
  height: 10px;
  background-color: var(--nav_kong_bg);
}

/* 下半部分 */
.nav_footer {
  width: 100%;
  background-color: var(--body_bg);
}

.nav_withdraw {
  width: 100%;
  height: 52px;
}

.nav_withdraw a {
  display: block;
  height: 52px;
  line-height: 52px;
  margin: 0 15px;
  border-bottom: 1px solid #ccc;
  color: #888af0;
}

.popup {
  width: 50%;
  height: 100%;
}

.popopMenu {
  height: 100%;
  background: #f2f2f6;
  padding-top: 20px;
}

.popup .cell {
  padding: 0;
  font-size: 15px;
  line-height: 16px;
}

.popup .cell2 {
  margin-top: 10px;
}
</style>
